import React, { createContext, useState } from "react";
import { getCookie } from "../components/Cookie.jsx";

export const ImageContext = createContext();

export const ImageProvider = ({ children }) => {
  const [imageResponse, setImageResponse] = useState([]);
  const [rowId, setRowId] = useState(null);
  const [dashboardIds, setDashboardIds] = useState([]);
  const [functionalityIds, setFunctionalityIds] = useState([]);
  const [userRoleId, setUserRoleId] = useState(null);
  const [roleActive, setRoleActive] = useState(false);

  const token = getCookie("sqa_token");
  const imageApiCall = async (id) => {
    try {
      const url = `/sqa/api/batch_image_retreival/?batchId=${id}`;
      const response = await fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      const data = await response.json();

      if (data?.result?.length > 0) {
        setImageResponse(data?.result[0]);
      } else {
        setImageResponse([]);
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  return (
    <ImageContext.Provider
      value={{
        imageResponse,
        setImageResponse,
        imageApiCall,
        rowId,
        setRowId,
        dashboardIds,
        setDashboardIds,
        functionalityIds,
        setFunctionalityIds,
        userRoleId,
        setUserRoleId,
        roleActive,
        setRoleActive,
      }}
    >
      {children}
    </ImageContext.Provider>
  );
};
